<template>
  <el-form :inline="true" :model="filters" :size="size">
    <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.sharedStatus"
        placeholder="共享状态"
      >
        <el-option
          v-for="(item, i) in sharedData"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="select_btn_160">
      <el-select
        class="select_btn_style"
        v-model="filters.displayClientTypes"
        placeholder="展示终端"
        multiple
        collapse-tags
      >
        <el-option
          v-for="(item, i) in typeList"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item>
      <el-cascader
        v-model="pid"
        placeholder="请选择期刊"
        :options="cascadeTree"
        :props="props"
        clearable
        @change="handleChange"
      ></el-cascader>
    </el-form-item>
    <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.onlineStatus"
        placeholder="上线状态"
      >
        <el-option label="全部" value=""></el-option>
        <el-option
          v-for="(item, i) in onlineStatusData"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="m-l-14">
      <el-input
        clearable
        prefix-icon="el-icon-search"
        v-model="filters.articleTitle"
        placeholder="文章标题"
      ></el-input>
    </el-form-item>
    <el-form-item>
      <butn btntype="primary" title="查询" @click.native="initData"></butn>
      <butn :title="'重置'" @click.native="resetData" class="czButn"></butn>
    </el-form-item>
  </el-form>
</template>
<script>
import butn from "@/components/button/index";
import { articleCascade } from "@/api/periodicalArticle";
import { getSysParamByTypes } from "@/api/sysParam";
export default {
  name: "search",
  components: {
    butn,
  },
  data() {
    return {
      size: "small",
      filters: {
        displayClientTypes: [],
      },
      onlineStatusData: [],
      cascadeTree: [],
      sharedData: [],
      pid: [],
      props: {
        //树形
        value: "id",
        label: "name",
        children: "children",
        checkStrictly: true,
      },
      typeList: [],
    };
  },
  created() {
    this.getSysParamByTypes([
      "ONLINE_STATUS",
      "DISPLAY_CLIENT_TYPE",
      "SHARED_SCREEN_STATUS",
    ]);
    const emptyObj = Object.create(null);
    this.filters = emptyObj;
    articleCascade().then((res) => {
      if (!res || res.code != 0) return;
      this.cascadeTree = res.data;
    });
  },
  methods: {
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({ types: types }).then((res) => {
        if (!res || res.code != 0) return;
        // res.data["ONLINE_STATUS"].splice(0, 0, {
        //   paramKey: "",
        //   paramValue: "全部",
        // });
        res.data["DISPLAY_CLIENT_TYPE"].splice(0, 0, {
          paramKey: "",
          paramValue: "全部",
        });
        res.data["SHARED_SCREEN_STATUS"].splice(0, 0, {
          paramKey: "",
          paramValue: "全部",
        });
        this.onlineStatusData = res.data["ONLINE_STATUS"] || [];
        this.typeList = res.data["DISPLAY_CLIENT_TYPE"] || [];
        this.sharedData = res.data["SHARED_SCREEN_STATUS"] || [];
      });
    },
    initData() {
      let searchParams = JSON.parse(JSON.stringify(this.filters));
      if (searchParams.displayClientTypes && searchParams.displayClientTypes.includes("")) {
        delete searchParams.displayClientTypes;
      }
      //查询
      this.$emit("search", { ...searchParams, t: new Date().getTime() });
    },
    handleChange(value) {
      this.filters.periodicalId = "";
      this.filters.periodicalYear = "";
      this.filters.periodId = "";
      if (value.length >= 1) {
        this.filters.periodicalId = value[0];
      }
      if (value.length >= 2) {
        this.filters.periodicalYear = value[1].split("-")[1];
      }
      if (value.length >= 3) {
        this.filters.periodId = value[2];
      }
    },
    resetData() {
      //重置
      this.pid = [];
      this.filters = {};
      this.$emit("search", { t: new Date().getTime() });
    },
  },
};
</script>
